import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
/** @deprecated */
export const useFormSubmit = ({ method, href }) => useCallback((ev) => {
    if (method !== 'POST' || !href) {
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    const { origin, pathname, searchParams } = new URL(href || '');
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', [origin, pathname].join(''));
    for (const [key, value] of searchParams.entries()) {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', value);
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
}, []);
//# sourceMappingURL=useFormSubmit.js.map